import { render, staticRenderFns } from "./CandidatePromeritumFeedback.vue?vue&type=template&id=456b300d&scoped=true"
import script from "./CandidatePromeritumFeedback.vue?vue&type=script&lang=js"
export * from "./CandidatePromeritumFeedback.vue?vue&type=script&lang=js"
import style0 from "./CandidatePromeritumFeedback.vue?vue&type=style&index=0&id=456b300d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b300d",
  null
  
)

export default component.exports